export enum API_TARGET {
  CLOUD,
  INTEGRATION,
}
